import {Component, DestroyRef, OnInit, inject} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {SalesService} from 'src/app/services/sales.service';
import {phoneValidator} from '../../validators/form-validator';
import {environment} from 'src/environments/environment';
import {EventsManager} from 'src/app/events/events.manager';

@Component({
  selector: 'app-invite-a-friend',
  templateUrl: './invite-a-friend.component.html',
  styleUrls: ['./invite-a-friend.component.scss'],
  standalone: false
})

export class InviteAFriendComponent implements OnInit {
  private _destroyRef: DestroyRef = inject(DestroyRef);
  public ngbActiveModal: NgbActiveModal = inject(NgbActiveModal);
  private _eventsManager: EventsManager = inject(EventsManager);
  private _salesService: SalesService = inject(SalesService);

  public token: string = '';
  private _url: string = '';
  public showCaptchaError: boolean = false;
  public successMessage: boolean = false;
  public captcha: string = environment.publicCaptchaKey;
  public sendInviteForm: FormGroup = new FormGroup({
    phoneNumber: new FormControl('', [Validators.required, phoneValidator])
  });
  private _office: any = {};

  public ngOnInit(): void {
    this._office = this._eventsManager.getOfficeInfo();
  }

  public sendInvitation(): void {
    this.showCaptchaError = false;
    if (this.token !== '') {
      this._url = this._office == null ? location.origin :  location.origin + '/office/'+ this._office.practiceId;
      const phoneNum = this.sendInviteForm.controls['phoneNumber'].value;
      const captchaRes = this.token;
      this._salesService.sendInvitation(phoneNum, captchaRes, this._url)
        .pipe(takeUntilDestroyed(this._destroyRef))
        .subscribe(()=>
          this.successMessage = true
        );
    } else {
      this.showCaptchaError = true;
    }
  }
}
